<script setup lang="ts">
import type { EsProduct } from '~/types/elastic'
import type { ProductLabel } from '~/types/misc'

const { loadLayout, tooltips } = useLayout()
await loadLayout()

const props = defineProps<{ product: EsProduct, showTooltip?: boolean }>()

const fixedLabels: Record<string, ProductLabel> = {
  showroom: {
    slug: 'showroom-model',
    label: 'Showroommodel',
    style: undefined,
    tooltip: undefined,
  },
  deliveryTime: {
    slug: 'snel-leverbaar',
    label: 'Snel leverbaar',
    style: { backgroundColor: '#fff', color: '#000' },
    tooltip: undefined,
  },
}

const dynamicLabels = computed<ProductLabel[]>(() => {
  return props.product?.marketingLabel?.map((item: any) => {
    return {
      slug: stringToSlug(item.label),
      label: item.label || '',
      style: {
        backgroundColor: item.swatch || undefined,
        color: item.swatch ? useContrastColor(item.swatch, '#fff', '#282827') : undefined,
      },
    }
  }) || [] as ProductLabel[]
})

const combinedLabels = computed<ProductLabel[]>(() => {
  return [
    props.product.isShowroom === 'yes' ? fixedLabels.showroom : null,
    props.product.deliveryTime === 0 || (props.product.deliveryTime > 1 && props.product.deliveryTime < 28) ? fixedLabels.deliveryTime : null,
    ...dynamicLabels.value,
  ].filter(item => item !== null) as ProductLabel[]
})

const labels = computed<ProductLabel[]>(() => {
  return combinedLabels.value.map((item: ProductLabel) => {
    if (props.showTooltip) {
      const tooltip = tooltips.value.get(item.slug)
      if (tooltip) {
        item.tooltip = tooltip.Richtext
      }
    }
    return item
  }) as ProductLabel[]
})
</script>

<template>
  <template
    v-for="label in labels"
    :key="label.label"
  >
    <ProductLabelTooltip
      v-if="label.tooltip && showTooltip"
      class="label label--marketing"
      :label="label"
    />
    <ProductLabel
      v-else
      class="label label--marketing"
      :label="label"
    />
  </template>
</template>

<style>
@import url("~layers/app/components/Product/Labels.css");
</style>
